<header class="modal__header">
  <div class="modal__heading">
    <h2 mat-dialog-title class="modal__title">{{ title() }}</h2>
    @if (subtitle(); as text) {
      <p class="modal__subtitle">{{ text }}</p>
    }
  </div>

  @if (closable()) {
    <button
      type="button"
      class="modal__close"
      [attr.aria-label]="'components.modal.close' | translate"
      (click)="dismissed.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</header>

<div class="modal__body">
  <ng-content />
</div>

<!-- sci-modal-footer brings its own chrome, so omitting it leaves no empty bar
     behind and the modal needs no emptiness check of its own. -->
<ng-content select="sci-modal-footer" />

@if (loading()) {
  <sci-loader mode="cover" [label]="'components.loader.label' | translate" />
}
